export default "__VITE_ASSET__BkkO4Htr__"